import { LogLevel } from '@wix/panorama-common-shared/types';
const messageFormatter = (artifactId, componentId, message) => {
  return ['%c%s %c%s %c%s %c%s', 'color: #D39874', 'Panorama logger:', 'color: #CAB6D3', `${artifactId}`, 'color: #B3CAD8', `${componentId}`, 'color: #A6C6DB', `${message}`];
};
export const logToConsole = (logLevel, artifactId, componentId, message, data) => {
  const formattedMessage = messageFormatter(artifactId, componentId, message);
  if (logLevel === LogLevel.Info) {
    console.info(...formattedMessage);
  } else if (logLevel === LogLevel.Warn) {
    console.warn(...formattedMessage);
  } else if (logLevel === LogLevel.Error) {
    console.error(...formattedMessage);
  } else if (logLevel === LogLevel.Debug) {
    console.debug(...formattedMessage);
  } else {
    console.log(...formattedMessage);
  }
  if (data && Object.keys(data).length) {
    console.table(data);
  }
};
//# sourceMappingURL=console-utils.js.map